import { createContext, useContext } from "react";
import type { ApiClient } from "@cntrl/api-client";
import type { TokenProvider } from "@cntrl/native";

/** The app singletons created once at bootstrap (Bootstrap.tsx) and shared through React + the router context. */
export interface AppServices {
  api: ApiClient;
  tokenProvider: TokenProvider;
}

const AppContext = createContext<AppServices | null>(null);

export const AppProvider = AppContext.Provider;

/** Access the API client + TokenProvider. Throws outside the provider (a wiring bug, not a runtime case). */
export function useApp(): AppServices {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp() must be used within <AppProvider> (Bootstrap).");
  return ctx;
}
